<template>
    <div class="container-fluid">
        <div class="row">
            <TableListStock/>
        </div>
    </div>
</template>
<script setup>
import { ref, defineAsyncComponent } from 'vue'
const TableListStock = defineAsyncComponent(() => import("@/components/theme/receipt-product/TableListReceipt.vue"))
</script>